import { render, staticRenderFns } from "./DropFiles.vue?vue&type=template&id=4b1cf64c&scoped=true"
import script from "./DropFiles.vue?vue&type=script&lang=js"
export * from "./DropFiles.vue?vue&type=script&lang=js"
import style0 from "./DropFiles.vue?vue&type=style&index=0&id=4b1cf64c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1cf64c",
  null
  
)

export default component.exports